<template>
    <div>
        <el-form :inline="true" :model="form1" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">

            <el-form-item label="">
                <el-button type="success" @click="getList()">查询</el-button>
                <el-button type="primary" @click="add()">新增</el-button>
            </el-form-item>
        </el-form>
        <el-form label-width="1px">
            <el-form-item>
                <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize"
                          v-loading="loading" width="180">
                    <el-table-column type="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column prop="ruleId" label="标识">
                    </el-table-column>
                    <el-table-column prop="ruleTypeName" label="折扣类型名称">
                    </el-table-column>
                    <el-table-column prop="start" label="开始区间" width="70">
                    </el-table-column>
                    <el-table-column prop="end" label="结束区间" width="70">
                    </el-table-column>
                    <el-table-column prop="discount" label="折扣" width="90">
                        <template slot-scope="scope">
                            <span>打{{scope.row.discount * 100}}折</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createUsername" label="创建人" width="70">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="190">
                    </el-table-column>
                    <el-table-column label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button type="primary" size="mini"
                                           @click="edit(scope.row)">编辑
                                </el-button>
                                <el-button type="warning" size="mini"
                                           @click="delete(scope.row)">删除
                                </el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="formInline.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline.recordsTotal">
                    </el-pagination>
                </div>
            </el-form-item>
        </el-form>
        <el-dialog title="添加/修改" :visible.sync="showDialog" label-width="100px" class="demo-ruleForm">
            <el-form >
                <el-form-item label="自增主键" v-show="false">
                    <el-input v-model="form.ruleId" placeholder="自增主键"></el-input>
                </el-form-item>
                <el-form-item label="折扣类型">
                    <el-select v-model="form.ruleType" clearable filterable placeholder="请选择折扣类型">
                        <el-option v-for="item in rulelist"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始区间">
                    <el-input-number v-model="form.start"
                              placeholder="包含当前"></el-input-number>
                </el-form-item>
                <el-form-item label="结束区间">
                    <el-input-number v-model="form.end" placeholder="不包含"></el-input-number>
                </el-form-item>
                <el-form-item label="折扣">
                    <el-input-number v-model="form.discount" :step="0.01" step-strictly :max="1" :min="0.01" placeholder="98折写0.98 9折写0.9 "></el-input-number>
                </el-form-item>
                <el-form-item label="bindCode" v-show="false">
                    <el-input v-model="form.bindCode" placeholder="98折写0.98 9折写0.9 "></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveItem()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveCutRuleList,
        deleteCutRule,
        saveCutRule
    } from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    bindCode: this.$route.query.bindCode,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                list: [],
                rulelist:[{id:1,name:"配送次数"},{id:2,name:"下单金额"}],
                showDialog: false,
                loading: true,
                form:{
                    ruleId:'',
                    ruleType:1,
                    bindCode:this.$route.query.bindCode,
                    start:1,
                    end:2,
                    discount:0.99
                }
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        computed: {},
        methods: {
            addPrice(){
                this.priceList.push(this.price);
            },
            deleteActiveItemPrice(row){
                this.removeAaary(this.priceList, row);
                //this.saveItemSalePriceList(this.priceList);
            },
            handleAddProduct(){

            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            edit(row){
                this.showDialog=true
                this.form={
                    ruleId:row.ruleId,
                        ruleType:row.ruleType,
                        bindCode:row.bindCode,
                        start:row.start,
                        end:row.end,
                        discount:row.discount
                }
            },
            add(){
                this.showDialog=true
                this.form={
                    ruleId:'',
                        ruleType:1,
                        bindCode:this.$route.query.bindCode,
                        start:1,
                        end:2,
                        discount:0.99
                }
            },
            getList(){
                this.loading = true
                getActiveCutRuleList(this.formInline).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            saveItem(){
                this.loading = true;
                saveCutRule(this.form).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getList();
                        this.showDialog = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            delete(data){
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deleteCutRule({ruleId:data.ruleId}).then((res) => {
                        this.loading = false;
                        if (res.data.status == 200) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getList();
                            this.showDialog = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/activeCutRule.vue